import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '&$multiline': {
        whiteSpace: 'pre-wrap',
        display: '-webkit-box',
        '-webkit-line-clamp': 'var(--max-lines, 3)', // default to 3 lines if not specified
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
    multiline: {},
    tooltip: {},
  }),
  { name: 'TruncatedTypography' }
);
